/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop, getAssetPath } from '@stencil/core';

import type { IconName, IconNameType } from './icon.types';

@Component({
  tag: 'efb-icon',
  styleUrl: 'icon.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class EfbIcon {
  @Prop() name: IconName | IconNameType;

  render() {
    return (
      <Host>
        <ion-icon src={getAssetPath(`assets/${this.name}.svg`)} />
      </Host>
    );
  }
}
